import gql from 'graphql-tag'
import ProjectOverviewPage from './projectOverviewPage'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RigipsStore } from 'redux/redux'

export const PROJECT_QUERY = gql`
  query getProject($projectId: String!) {
    getProject(projectId: $projectId) {
      projectNumber
      projectName
      projectSumNetto
      projectSumBrutto
      tax
      projectDetails {
        tax
      }
      positions {
        id
        systemDescription
        amount
        unit
        unitPrice
        totalPrice
      }
    }
  }
`

export const RANK_POSITION_MUTATION = gql`
  mutation rankPosition(
    $version: String!
    $projectNumber: String!
    $newPosition: Float!
    $oldPosition: Float!
  ) {
    rankPosition(
      version: $version
      projectNumber: $projectNumber
      newPosition: $newPosition
      oldPosition: $oldPosition
    )
  }
`

export const DELETE_POSITION_MUTATION = gql`
  mutation deletePosition($version: String!, $positionId: Float!, $projectId: String!) {
    deletePosition(version: $version, positionId: $positionId, projectId: $projectId)
  }
`

export const COPY_POSITIONS_MUTATION = gql`
  mutation copyPositions(
    $toVersion: String!
    $toProjectNumber: String!
    $fromPositionIds: [Float!]!
    $fromVersions: [String!]!
    $from_projectNumber: String!
  ) {
    copyPositions(
      toVersion: $toVersion
      toProjectNumber: $toProjectNumber
      fromPositionIds: $fromPositionIds
      fromVersions: $fromVersions
      from_projectNumber: $from_projectNumber
    )
  }
`

const mapStateToProps = (state: RigipsStore) => {
  const { auth } = state

  return { auth }
}

export default connect(mapStateToProps)(withRouter(ProjectOverviewPage))
